import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentalObjectCategory } from '../../model/const/enums';
import { CreateContractCommandHandler } from '../../service/command/create-contract-command-handler.service';
import { VacantCommandHandlerResolver } from '../../service/command/vacant-command-handler-resolver.service';
import { VacantPremisesCommandHandlerResolver } from '../../service/command/vacant-premises-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { VacantRentalObjectService } from '../../service/data/vacant-period.service';
import { VacantRentalObjectComponentBase } from '../base/vacant-rental-object.base';

@Component({
    selector: 'app-vacant-premises',
    templateUrl: './vacant-premises.component.html',
    styleUrls: ['./vacant-premises.component.scss'],
    providers: [
        CreateContractCommandHandler,
        VacantPremisesCommandHandlerResolver,
        { provide: 'category', useValue: RentalObjectCategory.Premises },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacantPremisesComponent extends VacantRentalObjectComponentBase {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    messageService: MessageService,
    navigation: NavigationService,
    service: VacantRentalObjectService,
    dispatcher: CommandDispatcher,
    handlerResolver: VacantCommandHandlerResolver
  ) {
    super(columnDefinitionService, messageService, navigation, service, dispatcher, handlerResolver);
  }

  protected get category(): RentalObjectCategory {
    return RentalObjectCategory.Premises;
  }

  onRowClicked(e: { context: any; event: any }): void {
    this.navigation.navigate(['vacantpremises', 'edit', e.context.rentalObjectId], null, e.event.ctrlKey);
  }
}
